// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 2H1.5V22.7038L6.87574 18H22.5V2ZM8.28788 6.55546C9.30471 5.53862 10.9197 5.48455 12.0002 6.39325C13.0806 5.48455 14.6957 5.53862 15.7125 6.55546C16.7864 7.6294 16.7864 9.3706 15.7125 10.4445L12.0002 14.1569L8.28788 10.4445C7.21394 9.3706 7.21394 7.6294 8.28788 6.55546Z"}}]};

const ChatHeartFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chat-heart-filled',
    ref,
    icon: element,
  },
));

ChatHeartFilledIcon.displayName = 'ChatHeartFilledIcon';

export default ChatHeartFilledIcon;
